/* global RedfastEnabled */
import React from 'react';
import PropTypes from 'prop-types';

import {
  FEATURED_BANNER_2ND,
  FEATURED_BANNER_3RD,
  FEATURED_BANNER_4TH,
  FEATURED_BANNER_TOP,
  LISTEN_BANNER_TOP,
  PERSONALITIES_BANNER_TOP,
  SHOWS_BANNER_TOP,
} from 'helpers/EngagementPlacements';

const RedFastBanner = ({ zone }) => {
  if (!zone || !RedfastEnabled) return null;
  return <div data-rf-zone={zone} />;
};

RedFastBanner.propTypes = {
  zone: PropTypes.oneOf([
    FEATURED_BANNER_2ND,
    FEATURED_BANNER_3RD,
    FEATURED_BANNER_4TH,
    FEATURED_BANNER_TOP,
    LISTEN_BANNER_TOP,
    PERSONALITIES_BANNER_TOP,
    SHOWS_BANNER_TOP,
  ]).isRequired,
};

export default RedFastBanner;
